<template>
  <div id="app">
    <RouterView />
  </div>
</template>

<style>
@import "./assets/css/app.scss";
@import "./assets/css/resetr.css";
</style>

<script>
  import RouterView from 'vue-router'

	export default {
	}
</script>
